import { Box, HStack, Icon, Image, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import QuoteIcon from "assets/icons/medium/quote.svg?react";

type AgentFeedbackSectionProps = {
  profileImage?: string;
  bodyText?: string;
  agentName?: string;
  date?: string;
};

export function AgentFeedbackSection({
  profileImage,
  bodyText,
  agentName,
  date,
}: AgentFeedbackSectionProps) {
  return (
    <VStack gap={{ base: 10, sm: 12, md: 14 }}>
      <VStack gap={2}>
        {profileImage ? (
          <Image
            borderRadius={"full"}
            boxSize={"120px"}
            src={profileImage}
            alt={"Agent image"}
            objectFit={"cover"}
          />
        ) : null}

        <Text fontSize={"3xl"} fontWeight={500}>
          Update from {agentName}
        </Text>
        <Text fontSize={"xl"} fontWeight={500}>
          {dayjs(date).format("DD MMMM")}
        </Text>
      </VStack>
      <HStack>
        <Box
          pos={"relative"}
          bgColor={"gray.50"}
          px={12}
          py={16}
          borderRadius={"8px"}
          maxW={"800px"}
        >
          <Icon
            as={QuoteIcon}
            boxSize={"24px"}
            color={"gray.900"}
            pos={"absolute"}
            left={12}
            top={[4, 8]}
          />
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            fontWeight={400}
            maxW={"1200px"}
            px={{ base: 0, md: 10, lg: 20 }}
          >
            {bodyText}
          </Text>
          <Icon
            as={QuoteIcon}
            boxSize={"24px"}
            color={"gray.900"}
            pos={"absolute"}
            right={12}
            bottom={[4, 8]}
            transform={"rotate(180deg)"}
          />
        </Box>
      </HStack>
    </VStack>
  );
}
